import React, { ReactElement } from 'react';
import useStyles from './styles';
import List, { ListProps } from '@material-ui/core/List';
import { ListItem, ListItemProps } from '@material-ui/core';

interface IProps<T> {
  data: T[];
  renderElement: (_data: T, index: number) => ReactElement;
  onElementClick?: (_data: T, index: number) => void;
  itemContainerProps?:
    | Omit<ListItemProps<any>, 'children'>
    | ((_data: T, index: number) => Omit<ListItemProps<any>, 'children'>);
  listContainerProps?: Omit<Partial<ListProps>, 'children'>;
  direction?: 'horizontal' | 'vertical';
  overrideParent?: boolean;
}

const horizontalStyling: React.CSSProperties = {
  flexDirection: 'row',
  display: 'flex',
  overflowX: 'auto',
};

export default function DataList<T extends {}>(props: IProps<T>): ReactElement {
  const classes = useStyles({});

  return (
    <div className={classes.root}>
      <List
        {...props.listContainerProps}
        style={{
          ...(props.direction === 'horizontal' ? horizontalStyling : {}),
          ...props.listContainerProps?.style,
        }}
      >
        {props.data.map((_data, index) => {
          if (props.overrideParent) {
            return (
              <div
                onClick={() =>
                  props?.onElementClick && props.onElementClick(_data, index)
                }
                key={index}
              >
                {props.renderElement(_data, index)}
              </div>
            );
          } else {
            return (
              <ListItem
                {...(typeof props.itemContainerProps === 'function'
                  ? props.itemContainerProps(_data, index)
                  : props.itemContainerProps)}
                onClick={() =>
                  props?.onElementClick && props.onElementClick(_data, index)
                }
                key={index}
              >
                {props.renderElement(_data, index)}
              </ListItem>
            );
          }
        })}
      </List>
    </div>
  );
}
